/*
 * サブシステム名：XXXX
 * 機能名：運行実績登録
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import complements from '@/rahmen/complement'

import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdDateBox = () => import('@/components/DdDateBox.vue')
const DdCheckbox = () => import('@/components/DdCheckbox.vue')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDropDown = () => import('@/components/DdDropDown.vue')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton.vue')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'PrmUnkoJissekiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdNumericBox,
    DdRadioButton,
    DdSubHeader,
    DdTextBox,
    DdTextArea,
    DdTimeBox
  },
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},
    haishaEigyoshoCd: '',
    modeOfEdit: 2,
    modeKengen: 2,
    showCopyDialog: false,
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstSharyoHeaders: header.mstSharyoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    isRequiredUnkoYmd: false,
    isRequiredSharyoNo: false,
    isRequiredShozokuEigyoshoId: false,
    isRequiredHacchusakiId: false
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredHacchusakiShashuSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filteredShozokuEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    filteredSharyoList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && (self.eigyoshoLockFlg || elem.eigyoshoCd === this.haishaEigyoshoCd)
      })
    },
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === true
      })
    },
    filteredHacchusakiJomuinList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '03'
      })
    },
    isDeleteDisable () {
      return this.id === 0
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      console.log('モード', this.modeOfEdit, this.modeKengen)
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isReadOnlyDisplay () {
      if (this.modeOfEdit !== 0) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        console.log('★fetchData', self)
        console.log('★going to get', self.id)
        this.HttpClient
          .get(`/api/v1/D2prmd0510/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload
            self.rec.jissekiShukkoHms = complements.parseTime(self.rec.jissekiShukkoHms, false).substr(0, 5)
            self.rec.jissekiKikoHms = complements.parseTime(self.rec.jissekiKikoHms, false).substr(0, 5)
            self.rec.jissekiShimeFlgDisp = self.rec.jissekiShimeFlg ? '実績締済み' : ''
            self.rec.digitakoTorikomiFlgDisp = self.rec.digitakoTorikomiFlg ? '取込済み' : ''
            delete self.rec.unkoYmd
            delete self.rec.jissekiShukkoYmd
            delete self.rec.jissekiKikoYmd
            self.onChangeHaishaKbn()

            console.log('recived data', this.rec)
            resolve()
          })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'vwcmstsharyo', 'msttorihikisaki', 'vwcmsteigyoshojininlist', 'mstshubetsu'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            const target = filter.dateFormatter(new Date())
            self.rec = {
              unkoJissekiNo: '',
              haishaKbn: '01',
              shozokuEigyoshoId: indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.userEigyoshoCd, target).id,
              sharyoId: '',
              hacchusakiId: '',
              hacchusakiShaban: '',
              hacchusakiShashuSbt: null,
              hacchusakiJomuinId: '',
              hacchusakiBiko: '',
              unkoYmd: '',
              jissekiKakuninZumiFlg: 'false',
              jissekiShimeFlg: 'false',
              jissekiShimeId: '',
              jissekiShukkoYmd: '',
              jissekiShukkoHms: '',
              jissekiKikoYmd: '',
              jissekiKikoHms: '',
              shukkoBasho: '',
              kikoBasho: '',
              jomuinId: '',
              dojoshaId: '',
              kadouJikan: '',
              hatsuchiOdoMater: '',
              chakuchiOdoMater: '',
              sokoKyori: '',
              jisshaKyori: '',
              kushaKyori: '',
              untenJikan: '',
              sagyoJikan: '',
              taikiJikan: '',
              kyusokuJikan: '',
              digitakoTorikomiFlg: 'false',
              digitakoUnkoId: '',
              sosekisairyo: ''
            }
            self.onChangeHaishaKbn()
            console.log('initializeInputPromise')
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', self.rec)
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(`/api/v1/D2prmd0510/Delete?id=${self.id}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.unkoJissekiNo = ''
          self.rec.unkoJissekiNo = ''
          self.modeOfEdit = 0
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.id !== this.rec.id
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            console.log('★transition')
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    onChangeHaishaKbn: function (e) {
      const self = this
      const target = filter.dateFormatter(new Date())
      if (self.rec.haishaKbn === '01') {
        self.$set(self.rec, 'shozokuEigyoshoId', indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.userEigyoshoCd, target).id)
        self.$set(self, 'haishaEigyoshoCd', self.userEigyoshoCd)
        self.isRequiredUnkoYmd = true
        self.isRequiredSharyoNo = true
        self.isRequiredShozokuEigyoshoId = true
        self.isRequiredHacchusakiId = false
      } else if (self.rec.haishaKbn === '02') {
        self.isRequiredUnkoYmd = true
        self.isRequiredSharyoNo = true
        self.isRequiredShozokuEigyoshoId = true
        self.isRequiredHacchusakiId = false
      } else if (self.rec.haishaKbn === '03') {
        self.$set(self.rec, 'shozokuEigyoshoId', indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.userEigyoshoCd, target).id)
        self.$set(self, 'haishaEigyoshoCd', self.userEigyoshoCd)
        self.isRequiredUnkoYmd = true
        self.isRequiredHacchusakiId = true
        self.isRequiredSharyoNo = false
        self.isRequiredShozokuEigyoshoId = false
      }
    },
    inputEigyosho: function () {
      if (this.rec.haishaKbn !== '02') { return }
      this.$set(this, 'haishaEigyoshoCd', indexeddb.getRecord(this.eigyoshoList, this.rec.shozokuEigyoshoId).eigyoshoCd)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/D2prmd0510/Create', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/D2prmd0510/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      return true
    },
    deleteValidate: function () {
      return true
    }
  }
}
